import React, { FC, useMemo } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import Icon from '../../../../@shared/icon';
import { TGroupRowItemProps } from '../../../types/index.types';
import SubvalueRow from './subValueRow';
import FormatText from './formatText';
import { textContains } from '../../../../../utils/regex.utils';

const DynamicHeadingTag = ({ tag, className, children }) => React.createElement(tag || 'div', { className }, children);

const GroupRow: FC<TGroupRowItemProps> = (props) => {
  const { model, obj, index, toggleRow, expandedRows, showHiddenRightCells, searchTerm } = props;
  const hide = !expandedRows.includes(index);

  const tableSubRows = useMemo(() => {
    if (searchTerm) {
      const data = obj.items.filter((element) => {
        const plainText = model.rowTitlePlainText(element?.title?.value as string);
        return textContains(plainText, searchTerm);
      });
      return data;
    }
    return obj.items;
  }, [searchTerm]);

  return (
    <>
      <tr className="model-detail-specification-table__spec-category-row" onClick={(): void => toggleRow(index)}>
        <td
          className="model-detail-specification-table__left-most-cell model-detail-specification-table__spec-category-row-cell"
          colSpan={model.hideRowsHeader ? model.nOfVisibleColumn : model.nOfVisibleColumn + 1}
        >
          <DynamicHeadingTag
            className={`
                  model-detail-specification-table__spec-category-row__inner-box
                  ${hide ? 'model-detail-specification-table__spec-category-row__inner-box--border-visible' : ''}
              `}
            tag={model.groupHeadingTag}
          >
            {!model.hideAccordionTabIcon && (
              <Icon
                iconName={hide ? 'action-plus' : 'action-minus'}
                size={iconSize.mbl}
                extraClassName={hide ? 'table-plus-icon' : 'table-minus-icon'}
              />
            )}
            {obj.title && <FormatText text={obj?.title?.value as string} searchTerm={searchTerm} editable={true} tagname="span" />}
          </DynamicHeadingTag>
        </td>
      </tr>
      {tableSubRows &&
        tableSubRows.map((subObj, accIndex, subArr) => (
          <SubvalueRow
            key={
              subObj.title?.value + Math.random().toString() ||
              subObj.groupName?.value + Math.random().toString() ||
              `subValueRow-${accIndex}`
            }
            model={model}
            subObj={subObj}
            hide={hide}
            subArr={subArr}
            accIndex={accIndex}
            index={index}
            expandedRows={expandedRows}
            showHiddenRightCells={showHiddenRightCells}
            searchTerm={searchTerm}
          />
        ))}
    </>
  );
};

export default GroupRow;
